import React from 'react';
import { t } from 'react-switch-lang';
import { makeAutoObservable } from 'mobx';
import { observer } from 'mobx-react';
import DeleteButton from '../components/buttons/DeleteButton';
import LockedButton from '../components/buttons/LockedButton';
import UnlockedButton from '../components/buttons/UnlockedButton';
import EditButton from '../components/buttons/EditButton';
import Avatar from '../components/Avatar';
import UserAvatar from '../../images/user/user.png';
import appState from '../storages/mobx/appState';
import usersStorage from '../pages/Users/usersStorage';
import RestoreButton from '../components/buttons/RestoreButton';
import UserActionsButton from '../pages/Users/UserActionsButton';
import dictionaries from '../storages/mobx/dictionaries';

class UserModel {
  id = null;

  name = '';

  soname = '';

  surname = '';

  login = null;

  email = '';

  emailVerified = null;

  status = null;

  avatar = null;

  verified_at = null;

  deleted_at = null;

  remember_token = null;

  created_at = null;

  updated_at = null;

  group_id = 0;

  staffName = '';

  perfectum_id = '';

  get isUserDeleted() {
    return this.deleted_at !== null;
  }

  get userFullName() {
    return `${this.name} ${this.soname} ${this.surname} (${this.staffName} / ${this.userRoleName})`;
  }

  get userRoleName() {
    return dictionaries.userGroups[this.group_id];
  }

  constructor(user = null, autoObservable = true) {
    if (user) {
      this.id = user.id;
      this.name = user.name;
      this.soname = user.soname;
      this.surname = user.surname;
      this.login = user.login;
      this.email = user.email;
      this.emailVerified = user.emailVerified;
      this.status = user.status;
      this.avatar = user.avatar;
      this.verified_at = new Date(user.verified_at);
      this.deleted_at = user.deleted_at ? new Date(user.deleted_at) : null;
      this.remember_token = user.remember_token;
      this.created_at = new Date(user.created_at);
      this.updated_at = new Date(user.updated_at);
      this.group_id = user.group_id;
      this.staffName = user.staffName || '';
      this.perfectum_id = user.perfectum_id || '';
    }
    if (autoObservable) {
      makeAutoObservable(this);
    }
  }

  static getColumnsList = () => {
    const columns = [
      {
        name: t('users.ID'),
        selector: 'id',
        sortable: true,
        center: true,
        width: '50px',
        cell: (row) => (row.id > 0 ? row.id : ''),
      },
      {
        name: t('users.avatar'),
        selector: 'avatar',
        cell: (row) => <Avatar image={row.avatar || UserAvatar} haveCircle={false} />,
        sortable: true,
        center: true,
        width: '75px',
      },
      {
        name: t('users.name'),
        selector: 'name',
        sortable: true,
        center: false,
        cell: (row) => `${row.name}${row.soname ? ` ${row.soname}` : ''}${row.surname ? ` ${row.surname}` : ''}`,
      },
      // {
      //   name: t('users.soname'),
      //   selector: 'soname',
      //   sortable: true,
      //   center:true,
      // },
      // {
      //   name: t('users.surname'),
      //   selector: 'surname',
      //   sortable: true,
      //   center:true,
      // },
      // {
      //   name: t('users.login'),
      //   selector: 'login',
      //   sortable: true,
      //   center: true,
      // },
      {
        name: t('users.email'),
        selector: 'email',
        sortable: true,
        center: true,
      },
      // {
      //   name: t('users.emailVerified'),
      //   selector: 'emailVerified',
      //   cell: (row) => (row.emailVerified ? <i className="fa fa-check" /> : <i className="fa fa-minus-circle" />),
      //   sortable: true,
      //   center: true,
      // },
      // {
      //   name: t('users.status'),
      //   selector: 'status',
      //   cell: (row) => {
      //     switch (+row.status) {
      //       case 0:
      //         return <i className="fa fa-question" />;
      //       case 1:
      //         return <i className="fa fa-check" />;
      //       case -1:
      //         return <i className="fa fa-ban" />;
      //       default:
      //         return <i className="fa fa-asterisk" />;
      //     }
      //   },
      //   sortable: true,
      //   center: true,
      // },
      // {
      //   name: t('users.verified_at'),
      //   selector: 'verified_at',
      //   sortable: true,
      //   center:true,
      // },{
      //   name: t('users.deleted_at'),
      //   selector: 'deleted_at',
      //   sortable: true,
      //   center:true,
      // },{
      //   name: t('users.remember_token'),
      //   selector: 'remember_token',
      //   sortable: true,
      //   center:true,
      // },{
      //   name: t('users.created_at'),
      //   selector: 'created_at',
      //   sortable: true,
      //   center:true,
      // },{
      //   name: t('users.updated_at'),
      //   selector: 'updated_at',
      //   sortable: true,
      //   center:true,
      // }
      {
        name: t('users.Role'),
        selector: 'oid',
        cell: (row, index, column, id) => <span>{dictionaries.userGroups[row.group_id]}</span>,
        sortable: true,
        center: true,
      },
      {
        name: t('users.staffName'),
        selector: 'oid',
        cell: (row, index, column, id) => <span>{row.staffName}</span>,
        sortable: true,
        center: true,
      },
      {
        name: t('users.crmId'),
        selector: 'perfectum_id',
        cell: (row, index, column, id) => <span>{row.perfectum_id}</span>,
        sortable: true,
        center: true,
      },
      {
        name: t('users.actions'),
        selector: 'oid',
        cell: (row, index, column, id) => <UserActionsButton row={row} index={index} />,
        sortable: true,
        center: true,
      },
    ];
    // if (localStorage.getItem("usersTableColumns"))
    return columns;
  }

  static conditionalRowStyles = [
    {
      when: (row) => row.deleted_at !== null,
      style: {
        // backgroundColor: '',
        color: 'lightgray',
        '&:hover': {
          color: 'lightgray',
        },
      },
    },
    {
      when: (row) => row.id == usersStorage.currentUser,
      style: {
        backgroundColor: 'antiquewhite',
        // color: 'lightgray',
        // '&:hover': {
        //   color: 'lightgray',
        // },
      },
    },
  ];

  setUserId = (id) => this.id = id;
}

export default UserModel;
